import { JDSDatepickerCalendarRowProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSDatepickerCalendarRowProps>
  ): React.FC<JDSDatepickerCalendarRowProps> =>
  (props: JDSDatepickerCalendarRowProps) => {
    return <Component {...props} />;
  };
